import { createSlice } from '@reduxjs/toolkit';

export const INITIAL_STATE = {
  unreadCount: 0,
};

const messagingSlice = createSlice({
  name: 'messaging',
  initialState: {
    ...INITIAL_STATE,
  },
  reducers: {
    /**
     * Set the total number of unread messages (driver → dispatcher).
     * Call this after fetching thread summaries to keep the nav badge in sync.
     * @param {number} action.payload - The total unread count
     */
    setUnreadCount(state, action) {
      state.unreadCount = action.payload;
    },
    /**
     * Reset unread count to zero (e.g. on logout).
     */
    clearUnreadCount(state) {
      state.unreadCount = 0;
    },
  },
});

export const { setUnreadCount, clearUnreadCount } = messagingSlice.actions;

export default messagingSlice.reducer;
